import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import axios from 'axios';
import api from '../../../../services/api';
import { getPermissions, findPermission } from '../../../../services/auth';
import {
  dataAtualFormatada,
  formatnigCurrency,
  formatDateTimeToRender,
} from '../../../../utils/functions';
import { RECEBE_EMAIL } from '../../../../utils/constantsAnchors';
import { decrypt, encrypt } from '../../../../services/crypto';
import { dddTel } from '../../../../utils/functions';

import { useHistory } from 'react-router';

import Render from './EditRender';

const EMAIL_CONEXAO_OPTIONS = ['Smtp', 'SmtpComSsl', 'Exchange', 'AutenticacaoModerna'];

const normalizeEmailConexao = (value = EMAIL_CONEXAO_OPTIONS[0]) => {
  if (value === null || value === undefined) {
    return EMAIL_CONEXAO_OPTIONS[0];
  }

  if (typeof value === 'number') {
    return EMAIL_CONEXAO_OPTIONS[value] ?? EMAIL_CONEXAO_OPTIONS[0];
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (trimmed === '') {
      return EMAIL_CONEXAO_OPTIONS[0];
    }

    if (!EMAIL_CONEXAO_OPTIONS.includes(trimmed)) {
      const numeric = Number(trimmed);
      if (!Number.isNaN(numeric)) {
        return EMAIL_CONEXAO_OPTIONS[numeric] ?? EMAIL_CONEXAO_OPTIONS[0];
      }
    }

    return trimmed;
  }

  return EMAIL_CONEXAO_OPTIONS[0];
};

const serializeEmailConexao = (value) => normalizeEmailConexao(value);

function Edit({ id }) {
  const [inputs, setInputs] = useState({
    ancoraId: 0,
    bairro: '',
    cep: '',
    cnpj: '',
    complemento: '',
    condicao: 'Nenhum',
    contaCorrenteLimiteDiario: 0,
    contaCorrenteLimiteMensal: 0,
    custoCdi: 0,
    dataAberturaEmpresa: '',
    departamentoAntecipacao: '',
    emailAntecipacao: '',
    emailAssinaturaAlterado: true,
    emailAssinaturaBase64: '',
    emailAssinaturaLink: '',
    layoutEmailFechamentoMesId: 0,
    emailAuthentication: 'Desabilitado',
    emailExchange: 'Nao',
    emailHost: '',
    emailPassword: '',
    emailPort: 0,
    emailSecure: 'Desabilitado',
    emailUserName: '',
    emailConexao: normalizeEmailConexao(),
    emailClientId: '',
    emailObjectId: '',
    emailTenanId: '',
    emailClientSecret: '',
    emailRedirectUri: '',
    emailScopesUrl: '',
    emailOutlookDomain: '',
    emailAccessToken: '',
    emailAccessTokenValidate: null,
    emailRefreshToken: '',
    emailRefreshTokenValidate: null,
    estadoId: 0,
    layoutArquivoImportacaoId: 0,
    layoutArquivoExportacaoId: 0,
    layoutEmailAncoraId: 0,
    layoutEmailAntecipacaoAprovadaId: 0,
    layoutEmailAntecipacaoReprovadaId: 0,
    layoutEmailAntecipacaoVencidaId: 0,
    layoutEmailFornecedorId: 0,
    layoutEmailInteresseId: 0,
    linkDominoExterno: '',
    logotipoAlterado: true,
    logotipoImagemBase64: '',
    logotipoLink: '',
    logradouro: '',
    minimoDiasParaPagamento: 0,
    municipioId: 0,
    nomeFantasia: '',
    nomePastaArquivos: '',
    numero: 0,
    ordemTitulos: 'NumeroNotaFiscal',
    razaoSocial: '',
    status: 'Pendente',
    taxaPercentualMinimoAncora: 0,
    taxaPercentualMinimoCapittale: 0,
    taxaMediaMinimoMesRede: 0,
    processandoArquivo: 'Nao',
    emailAncoraAgrupado: 'Nao',
    segregadoPorLoja: 'Nao',
    apelido: '',
    ambiente: 'Desenvolvimento',
    horaLimiteAceiteProposta: '',
    controlaContaBancaria: 'Nao',
    controlaLoja: 'Nao',
    usarRazaoComCodigoInternoFornecedor: 'Nao',
    ftpHost: '',
    ftpPort: 0,
    ftpUserName: '',
    ftpPassword: '',
    ftpDirectory: '',
    ftpProtocolo: 'Ftp',
    ftpStatus: 'Inativo',
    aprovacaoAposHoraLimite: 'NaoPermitido',
    tipoLojaCodigo: 'Alfabético',
    fechamentoMes: 'MesAnterior',
    dataRegistro: '',
    dataAvaliacao: '',
    destinoPagamentoId: '0',
    valorMinimoParaQualificado: 0,
    valorMinimoParaNaoQualificado: 0,
    bancoFidcValorTarifaBancaria: 0,
    telefoneComercialNumero: '',
    horaLimiteAceitePropostaSegunda: '',
    horaLimiteAceitePropostaTerca: '',
    horaLimiteAceitePropostaQuarta: '',
    horaLimiteAceitePropostaQuinta: '',
    horaLimiteAceitePropostaSexta: '',
    obrigaDigitoAgencia: 'Nao',
    questionarFornecedoresAceitaAbatimentosDescontos: 'Nao',
    enviarArquivoExportacaoNaAprovacao: 'Nao',
    erp: '',
    tiposDadosBancarios: 'Todos',
    tipoResumoDiario: 'ApenasPagamentoDMais1',
    custoCdiAtualizacaoAutomatica: 'Nao',
    vencimentoTituloEmDMais: 0,
    telaDeOperacoesInformacoes: '',
    enviarEmailsDeInteresseAposProcessarArquivo: "",
    enviarWhatsAppAposProcessarArquivo: "",
    controlaCorporate: ""
  });
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const { lastGrid, filters } = useSelector((state) => state.anchors);

  const ancorasContatosRef = useRef();
  const ancorasTaxasFaixasRef = useRef();
  const ancorasLojasRef = useRef();

  const [getLoading, setLoading] = useState(true);
  const [getErros, setErros] = useState([]);

  const history = useHistory();
  const dispatch = useDispatch();

  const [getEstados, setEstados] = useState([]);
  const [getMunicipios, setMunicipios] = useState([]);
  const [inputsBlocked, setInputsBlocked] = useState([]);

  const [getAncorasContatos, setAncorasContatos] = useState([]);
  const [getAncorasLoadingContatos, setAncorasLoadingContatos] = useState(true);

  const [getAncorasLojas, setAncorasLojas] = useState([]);
  const [getAncorasLoadingLojas, setAncorasLoadingLojas] = useState(true);

  const [getAncorasTaxasFaixas, setAncorasTaxasFaixas] = useState([]);
  const [getAncorasLoadingTaxasFaixas, setAncorasLoadingTaxasFaixas] = useState(true);

  const [getLayoutsEmailsAncoras, setLayoutsEmailsAncoras] = useState([]);
  const [getLayoutsEmailsInteresses, setLayoutsEmailsInteresses] = useState([]);
  const [getLayoutsEmailsAntecipacoes, setLayoutsEmailsAntecipacoes] = useState([]);
  const [getLayoutsEmailsAntecipacoesAprovadas, setLayoutsEmailsAntecipacoesAprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesReprovadas, setLayoutsEmailsAntecipacoesReprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesVencidas, setLayoutsEmailsAntecipacoesVencidas] = useState([]);
  const [getLayoutsArquivoTitulosImportação, setLayotsArquivoTitulosImportação] = useState([]);
  const [getLayoutsArquivoTituloExportação, setLayotsArquivoTitulosExportação] = useState([]);
  const [getLayoutsEmailsFechamentosMeses, setLayoutsEmailsFechamentosMeses] = useState([]);

  const handleInputChange = (event, value) => {
    event.persist();
    const { name } = event.target;
    let nextValue = value ?? event.target.value;

    if (name === 'emailConexao') {
      nextValue = normalizeEmailConexao(nextValue);
    }

    setInputs((inputs) => ({
      ...inputs,
      [name]: nextValue,
      ...(name == 'custoCdiAtualizacaoAutomatica' && event.target.value == 1 ? { custoCdi: 0 } : {}),
    }));

    // inputs[event.target.name] = value || event.target.value;
    // setInputs(inputs);
  };

  const handleInputNumberChange = (event, value) => {
    inputs[event.target.name] = value || event.target.value;
    setInputs(inputs);
  };


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const base64 = await convertBase64(file);
      setInputs((inputs) => ({ ...inputs, [event.target.name]: base64 }));
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const getInfoForForm = async () => {
    try {
      const findAncorasContato = await api.get(`Ancoras/ConsultarId?id=${id}`);
      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      const findLayoutsEmailsAncoras = await api.get('LayoutsEmailsAncoras/Consultar?status=Ativo');
      const findLayoutsEmailsInteresses = await api.get(
        'LayoutsEmailsInteresses/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoes = await api.get(
        'LayoutsEmailsFornecedores/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesAprovadas = await api.get(
        'LayoutsEmailsAntecipacoesAprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesReprovadas = await api.get(
        'LayoutsEmailsAntecipacoesReprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesVencidas = await api.get(
        'LayoutsEmailsAntecipacoesVencidas/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosExportação = await api.get(
        'LayoutsArquivosExportacoes/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosImportação = await api.get(
        'LayoutsArquivosImportacoes/Consultar?status=Ativo',
      );
      const findLayoutsEmailsFechamentosMeses = await api.get(
        'LayoutsEmailsFechamentosMeses/Consultar?status=Ativo',
      );
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')

      setEstados(searchStates.data.resposta);
      setLayoutsEmailsAncoras(findLayoutsEmailsAncoras.data.resposta);
      setLayoutsEmailsInteresses(findLayoutsEmailsInteresses.data.resposta);
      setLayoutsEmailsAntecipacoes(findLayoutsEmailsAntecipacoes.data.resposta);
      setLayoutsEmailsAntecipacoesAprovadas(findLayoutsEmailsAntecipacoesAprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesReprovadas(findLayoutsEmailsAntecipacoesReprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesVencidas(findLayoutsEmailsAntecipacoesVencidas.data.resposta);
      setLayotsArquivoTitulosImportação(findLayoutsArquivoTitulosImportação.data.resposta);
      setLayotsArquivoTitulosExportação(findLayoutsArquivoTitulosExportação.data.resposta);
      setLayoutsEmailsFechamentosMeses(findLayoutsEmailsFechamentosMeses.data.resposta);
      setDestinoOpcoes(destinos.data.resposta)

      const responseForInputs = findAncorasContato.data.resposta;

      dispatch(CreatorsAnchors.changeLastAnchor(responseForInputs.nomeFantasia));
      dispatch(CreatorsAnchors.changeLastAnchorStore(null));

      let dddVazio = '';

      if (responseForInputs.telefoneComercialDDD !== '') {
        dddVazio = `(${responseForInputs.telefoneComercialDDD}) `;
      }

      setInputs({
        ...responseForInputs,
        emailPassword: decrypt(responseForInputs.emailPassword),
        ftpPassword: decrypt(responseForInputs.ftpPassword),
        logotipoImagemBase64: responseForInputs.logotipoLink,
        emailAssinaturaBase64: responseForInputs.emailAssinaturaLink,
        telefoneComercialNumero: responseForInputs.telefoneComercialNumero && `${dddVazio}${responseForInputs.telefoneComercialNumero}`,
        // Mapeamento explícito dos novos campos
        emailClientId: responseForInputs.emailClientId || '',
        emailObjectId: responseForInputs.emailObjectId || '',
        emailTenanId: responseForInputs.emailTenanId || '',
        emailClientSecret: responseForInputs.emailClientSecret || '',
        emailRedirectUri: responseForInputs.emailRedirectUri || '',
        emailScopesUrl: responseForInputs.emailScopesUrl || '',
        emailOutlookDomain: responseForInputs.emailOutlookDomain || '',
        emailAccessToken: responseForInputs.emailAccessToken || '',
        emailAccessTokenValidate: responseForInputs.emailAccessTokenValidate || null,
        emailRefreshToken: responseForInputs.emailRefreshToken || '',
        emailRefreshTokenValidate: responseForInputs.emailRefreshTokenValidate || null,
        emailConexao: normalizeEmailConexao(responseForInputs.emailConexao),
      });
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  const getAllMunicipios = async () => {
    try {
      const searchCities = await api.get(
        `Municipios/ConsultarEstadoId?id=${inputs.estadoId}&status=Ativo`,
      );
      setMunicipios(searchCities.data.resposta);
      setInputs({ ...inputs, municipioId: inputs.municipioId });
    } catch (err) {
      toast.error('Falha ao consultar a lista de municípios');
    }
  };

  useEffect(() => {
    if (inputs.estadoId) {
      getAllMunicipios();
    }
  }, [inputs.estadoId]);

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 711, permissao: 'Alterar' });
    if (permissions) {
      getInfoForForm();
    } else {
      history.push('/app');
    }
  }, []);

  const handleSubmit = async (event) => {
    if (event && event.type !== 'submit') {
      event.preventDefault();
      setLoading(true);
      try {
        const newLogotipo = inputs.newLogotipoImagemBase64;
        const newAssinatura = inputs.newEmailAssinaturaBase64;

        delete inputs.newLogotipoImagemBase64;
        delete inputs.newEmailAssinaturaBase64;

        const response = await api.put('Ancoras', {
          // informações
          ancoraId: inputs.ancoraId && parseInt(inputs.ancoraId),
          cnpj: inputs.cnpj,
          status: inputs.status,
          razaoSocial: inputs.razaoSocial,
          nomeFantasia: inputs.nomeFantasia,
          apelido: inputs.apelido,
          departamentoAntecipacao: inputs.departamentoAntecipacao,
          linkDominioExterno: inputs.linkDominioExterno,
          dataAberturaEmpresa: inputs.dataAberturaEmpresa
            ? inputs.dataAberturaEmpresa && dataAtualFormatada(inputs.dataAberturaEmpresa)
            : null,
          // Financeiro
          custoCdi: inputs.custoCdi && parseFloat(inputs.custoCdi),
          minimoDiasParaPagamento:
            inputs.minimoDiasParaPagamento && parseInt(inputs.minimoDiasParaPagamento),
          taxaPercentualMinimoAncora:
            inputs.taxaPercentualMinimoAncora && parseFloat(inputs.taxaPercentualMinimoAncora),
          taxaPercentualMinimoCapittale:
            inputs.taxaPercentualMinimoCapittale &&
            parseFloat(inputs.taxaPercentualMinimoCapittale),
          taxaMediaMinimoMesRede:
            inputs.taxaMediaMinimoMesRede &&
            parseFloat(inputs.taxaMediaMinimoMesRede),
          contaCorrenteLimiteDiario:
            inputs.contaCorrenteLimiteDiario && parseFloat(inputs.contaCorrenteLimiteDiario),
          contaCorrenteLimiteMensal:
            inputs.contaCorrenteLimiteMensal && parseFloat(inputs.contaCorrenteLimiteMensal),
          fechamentoMes: inputs.fechamentoMes,
          destinoPagamentoId: Number(inputs.destinoPagamentoId),
          // Importação de Arquivo de Titulo
          layoutArquivoImportacaoId:
            inputs.layoutArquivoImportacaoId && parseInt(inputs.layoutArquivoImportacaoId),
          processandoArquivo: inputs.processandoArquivo,
          nomePastaArquivos: inputs.nomePastaArquivos,
          controlaLoja: inputs.controlaLoja,
          tipoLojaCodigo: inputs.tipoLojaCodigo,
          // Exportação de propostas aprovadas
          layoutArquivoExportacaoId:
            inputs.layoutArquivoExportacaoId && parseInt(inputs.layoutArquivoExportacaoId),
          ftpStatus: inputs.ftpStatus,
          ftpHost: inputs.ftpHost,
          ftpName: inputs.ftpName,
          ftpPassword: inputs.ftpPassword ? encrypt(inputs.ftpPassword) : inputs.ftpPassword,
          ftpProtocolo: inputs.ftpProtocolo,
          ftpPort: inputs.ftpPort && parseInt(inputs.ftpPort),
          ftpDirectory: inputs.ftpDirectory,
          // Informações de Email
          emailExchange: inputs.emailExchange,
          emailAuthentication: inputs.emailAuthentication,
          emailSecure: inputs.emailSecure,
          emailAntecipacacao: inputs.emailAntecipacacao,
          emailUserName: inputs.emailUserName,
          emailPassword: inputs.emailPassword ? encrypt(inputs.emailPassword) : inputs.emailPassword,
          emailHost: inputs.emailHost,
          emailPort: inputs.emailPort && parseInt(inputs.emailPort),
          // Novos campos de email
          emailConexao: serializeEmailConexao(inputs.emailConexao),
          emailClientId: inputs.emailClientId || '',
          emailObjectId: inputs.emailObjectId || '',
          emailTenanId: inputs.emailTenanId || '',
          emailClientSecret: inputs.emailClientSecret || '',
          emailRedirectUri: inputs.emailRedirectUri || '',
          emailScopesUrl: inputs.emailScopesUrl || '',
          emailOutlookDomain: inputs.emailOutlookDomain || '',
          emailAccessToken: inputs.emailAccessToken || '',
          emailAccessTokenValidate: inputs.emailAccessTokenValidate || null,
          emailRefreshToken: inputs.emailRefreshToken || '',
          emailRefreshTokenValidate: inputs.emailRefreshTokenValidate || null,
          // Layouts Emails
          layoutEmailAncoraId: inputs.layoutEmailAncoraId && parseInt(inputs.layoutEmailAncoraId),
          layoutEmailFechamentoMesId:
            inputs.layoutEmailFechamentoMesId && parseInt(inputs.layoutEmailFechamentoMesId),
          layoutEmailFornecedorId:
            inputs.layoutEmailFornecedorId && parseInt(inputs.layoutEmailFornecedorId),
          layoutEmailInteresseId:
            inputs.layoutEmailInteresseId && parseInt(inputs.layoutEmailInteresseId),
          layoutEmailAntecipacaoAprovadaId:
            inputs.layoutEmailAntecipacaoAprovadaId &&
            parseInt(inputs.layoutEmailAntecipacaoAprovadaId),
          layoutEmailAntecipacaoReprovadaId:
            inputs.layoutEmailAntecipacaoReprovadaId &&
            parseInt(inputs.layoutEmailAntecipacaoReprovadaId),
          layoutEmailAntecipacaoVencidaId:
            inputs.layoutEmailAntecipacaoVencidaId &&
            parseInt(inputs.layoutEmailAntecipacaoVencidaId),
          // Slip Pagamentos
          ordemTitulos: inputs.ordemTitulos,
          condicao: inputs.condicao,
          controlaContaBancaria: inputs.controlaContaBancaria,
          emailAncoraAgrupado: inputs.emailAncoraAgrupado,
          segregadoPorLoja: inputs.segregadoPorLoja,
          usarRazaoComCodigoInternoFornecedor: inputs.usarRazaoComCodigoInternoFornecedor,
          // endereço
          cep: inputs.cep ? inputs.cep : '',
          estadoId: inputs.estadoId && parseInt(inputs.estadoId),
          municipioId: inputs.municipioId && parseInt(inputs.municipioId),
          numero: inputs.numero ? inputs.numero && parseInt(inputs.numero) : 0,
          // Aprovação de Proposta
          aprovacaoAposHoraLimite: inputs.aprovacaoAposHoraLimite,
          horaLimiteAceiteProposta: inputs.horaLimiteAceiteProposta,
          // config
          ambiente: inputs.ambiente,
          // Logotipo
          logotipoAlterado: !!newLogotipo,
          logotipoImagemBase64: newLogotipo && newLogotipo.split(',').pop(),
          // Ass
          emailAssinaturaAlterado: !!newAssinatura,
          emailAssinaturaBase64: newAssinatura && newAssinatura.split(',').pop(),
          // Registro
          dataRegistro: inputs.dataRegistro && dataAtualFormatada(inputs.dataRegistro),
          dataAvaliacao: inputs.dataAtualizacao
            ? formatDateTimeToRender(inputs.dataAtualizacao)
            : '',
          valorMinimoParaQualificado:
            inputs.valorMinimoParaQualificado && parseFloat(inputs.valorMinimoParaQualificado),
          valorMinimoParaNaoQualificado: 
            inputs.valorMinimoParaNaoQualificado && parseFloat(inputs.valorMinimoParaNaoQualificado),
          bancoFidcValorTarifaBancaria:
            inputs.bancoFidcValorTarifaBancaria && parseFloat(inputs.bancoFidcValorTarifaBancaria),
          horaLimiteAceitePropostaSegunda: inputs.horaLimiteAceitePropostaSegunda,
          horaLimiteAceitePropostaTerca: inputs.horaLimiteAceitePropostaTerca,
          horaLimiteAceitePropostaQuarta: inputs.horaLimiteAceitePropostaQuarta,
          horaLimiteAceitePropostaQuinta: inputs.horaLimiteAceitePropostaQuinta,
          horaLimiteAceitePropostaSexta: inputs.horaLimiteAceitePropostaSexta,
          obrigaDigitoAgencia: inputs.obrigaDigitoAgencia,
          erp: inputs.erp,
          tiposDadosBancarios: inputs.tiposDadosBancarios,
          tipoResumoDiario: inputs.tipoResumoDiario,
          custoCdiAtualizacaoAutomatica: inputs.custoCdiAtualizacaoAutomatica,
          vencimentoTituloEmDMais: Number(inputs.vencimentoTituloEmDMais),
          enviarEmailsDeInteresseAposProcessarArquivo: inputs.enviarEmailsDeInteresseAposProcessarArquivo,
          enviarWhatsAppAposProcessarArquivo: inputs.enviarWhatsAppAposProcessarArquivo,
          controlaCorporate: inputs.controlaCorporate,
          // Spread dos inputs restantes
          ...inputs,
          // IMPORTANTE: Sobrescreve o telefone depois do spread para garantir formato correto
          telefoneComercialNumero:
            inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero) : '',
          telefoneComercialDDD: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero, 'ddd') : ''
        });

        console.log('📞 DEBUG TELEFONE:', {
          original: inputs.telefoneComercialNumero,
          ddd: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero, 'ddd') : '',
          numero: inputs.telefoneComercialNumero && inputs.telefoneComercialNumero.trim() !== '' ? dddTel(inputs.telefoneComercialNumero) : ''
        });
        console.info(response);

        if (response.data.status !== 'Inconsistencia') {
          setInputs({
            ...inputs,
            emailPassword: decrypt(response.data.resposta.emailPassword),
            ftpPassword: decrypt(response.data.resposta.ftpPassword),
            dataAtualizacao: response.data.resposta.dataAtualizacao,
            logotipoImagemBase64: response.data.resposta.logotipoLink,
            emailAssinaturaBase64: response.data.resposta.emailAssinaturaLink,
          });
          toast.success('Rede alterada com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = [];

            response.data.resposta.map((resposta) => {
              errosArray.push(resposta.key);

              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });

            setErros(errosArray);
          } else {
            toast.error('Não foi possível alterar a rede!');
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message);
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.');
        }
      }
      setLoading(false);
    } else if(event) {
      event.preventDefault();
    }
  };

  async function findAllAncorasContatos() {
    if (!findPermission(1554)) {
      return false;
    }
    setAncorasLoadingContatos(true);
    try {
      const anchorFilter = filters.find((x) => x.anchor === 'ancoras-contatos');

      const response = await api.get(
        `AncorasContatos/ConsultarAncoraId?id=${id}${
          anchorFilter.filter ? `&status=${anchorFilter.filter}` : ''
        }`,
      );

      const newStateContatos = response.data.resposta.length
        ? response.data.resposta.map((contato) => ({
            ...contato,
            telefone1:
              contato.telefone1 &&
              (contato.ddd1 ? `(${contato.ddd1}) ${contato.telefone1}` : `${contato.telefone1}`),
            telefone2:
              contato.telefone2 &&
              (contato.ddd2 ? `(${contato.ddd2}) ${contato.telefone2}` : `${contato.telefone2}`),
            receberEmailAntecipacoesAprovadas:
              contato.receberEmailAntecipacoesAprovadas === 'RecebePrincipal'
                ? RECEBE_EMAIL.RecebePrincipal
                : contato.receberEmailAntecipacoesAprovadas === 'NaoRecebe'
                ? RECEBE_EMAIL.NaoRecebe
                : RECEBE_EMAIL.RecebeCopia,
            receberEmailFechamentoMes:
              contato.receberEmailFechamentoMes === 'RecebePrincipal'
                ? RECEBE_EMAIL.RecebePrincipal
                : contato.receberEmailFechamentoMes === 'NaoRecebe'
                ? RECEBE_EMAIL.NaoRecebe
                : RECEBE_EMAIL.RecebeCopia,
          }))
        : [];
      setAncorasContatos(newStateContatos);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setAncorasLoadingContatos(false);
  }

  async function findAllAncorasLojas() {
    if (!findPermission(1216)) {
      return false;
    }
    setAncorasLoadingLojas(true);
    try {
      const anchorFilter = filters.find((x) => x.anchor === 'ancoras-lojas');

      const response = await api.get(
        `AncorasLojas/ConsultarAncoraId?id=${id}${
          anchorFilter.filter ? `&status=${anchorFilter.filter}` : ''
        }`,
      );
      setAncorasLojas(response.data.resposta);
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.');
    }
    setAncorasLoadingLojas(false);
  }

  async function findAllAncorasTaxasFaixas() {
    if (!findPermission(1828)) {
      return false;
    }
    setAncorasLoadingTaxasFaixas(true);
    try {
      const anchorFilter = filters.find((x) => x.anchor === 'ancoras-lojas');

      const response = await api.get(
        `AncorasTaxasFaixas/ConsultarAncoraId?id=${id}${
          anchorFilter.filter ? `&status=${anchorFilter.filter}` : ''
        }`,
      );

      const mapResponse = response.data.resposta.map((taxaFaixa) => ({
        ...taxaFaixa,
        valorInicial: taxaFaixa.valorInicial && formatnigCurrency(taxaFaixa.valorInicial),
        valorFinal: taxaFaixa.valorFinal && formatnigCurrency(taxaFaixa.valorFinal),
        taxa: taxaFaixa.taxa && `${taxaFaixa.taxa} %`,
      }));

      setAncorasTaxasFaixas(mapResponse);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setAncorasLoadingTaxasFaixas(false);
  }

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      const { logradouro, bairro, ibge } = response.data;

      if (logradouro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'logradouro']);
      }
      if (bairro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'bairro']);
      }

      if (ibge.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'estado', 'municipio']);
        const responseMunicipio = await api.get(`Municipios/ConsultarIBGEId?id=${ibge}`);
        const { estadoId, municipioId } = responseMunicipio.data.resposta[0];
        setInputs({ ...inputs, logradouro, bairro, estadoId, municipioId });

        const listFields = ['Cep', 'Logradouro', 'Bairro', 'EstadoId', 'MunicipioId'];

        setErros(
          getErros.filter(function (item) {
            return !listFields.includes(item);
          }),
        );
      } else {
        setInputs({ ...inputs, logradouro, bairro });
      }
    } catch (err) {
      setInputsBlocked([]);
    }
  };

  useEffect(() => {
    if (!getLoading) {
      if (lastGrid === 'ancoras-contatos') {
        findAllAncorasContatos();
        ancorasContatosRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (lastGrid === 'ancoras-taxas-faixas') {
        findAllAncorasTaxasFaixas();
        ancorasTaxasFaixasRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (lastGrid === 'ancoras-lojas') {
        findAllAncorasLojas();
        ancorasLojasRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      dispatch(CreatorsAnchors.changeLastGrid(null));
    }
  }, [getLoading]);

  return (
    <Render
      ancoraId={id}
      inputs={inputs}
      getLoading={getLoading}
      setInputs={setInputs}
      handleInputChange={handleInputChange}
      handleFileChange={handleFileChange}
      onSubmit={handleSubmit}
      findAllAncorasContatos={findAllAncorasContatos}
      getAncorasContatos={getAncorasContatos}
      getAncorasLoadingContatos={getAncorasLoadingContatos}
      findAllAncorasLojas={findAllAncorasLojas}
      getAncorasLojas={getAncorasLojas}
      getAncorasLoadingLojas={getAncorasLoadingLojas}
      findAllAncorasTaxasFaixas={findAllAncorasTaxasFaixas}
      getAncorasTaxasFaixas={getAncorasTaxasFaixas}
      getAncorasLoadingTaxasFaixas={getAncorasLoadingTaxasFaixas}
      ancorasContatosRef={ancorasContatosRef}
      ancorasTaxasFaixasRef={ancorasTaxasFaixasRef}
      ancorasLojasRef={ancorasLojasRef}
      lastGrid={lastGrid}
      findPermission={findPermission}
      getErros={getErros}
      setErros={setErros}
      findCep={findCep}
      inputsBlocked={inputsBlocked}
      getEstados={getEstados}
      getMunicipios={getMunicipios}
      getLayoutsEmailsAncoras={getLayoutsEmailsAncoras}
      getLayoutsEmailsInteresses={getLayoutsEmailsInteresses}
      getLayoutsEmailsAntecipacoes={getLayoutsEmailsAntecipacoes}
      getLayoutsEmailsAntecipacoesAprovadas={getLayoutsEmailsAntecipacoesAprovadas}
      getLayoutsEmailsAntecipacoesReprovadas={getLayoutsEmailsAntecipacoesReprovadas}
      getLayoutsEmailsAntecipacoesVencidas={getLayoutsEmailsAntecipacoesVencidas}
      getLayoutsArquivoTitulosImportação={getLayoutsArquivoTitulosImportação}
      getLayoutsArquivoTituloExportação={getLayoutsArquivoTituloExportação}
      getLayoutsEmailsFechamentosMeses={getLayoutsEmailsFechamentosMeses}
      destinoOpcoes={destinoOpcoes}
      handleInputNumberChange={handleInputNumberChange}
    />
  );
}

export default Edit;
